import { render } from "./PlanChangeModal.vue?vue&type=template&id=5fb475d4&scoped=true"
import script from "./PlanChangeModal.vue?vue&type=script&lang=js"
export * from "./PlanChangeModal.vue?vue&type=script&lang=js"

import "./PlanChangeModal.vue?vue&type=style&index=0&id=5fb475d4&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb475d4"]])

export default __exports__